<div class='form-group'>
	<label *ngIf='label'>{{label}}</label>
	<label *ngIf='customLabel'><ng-content></ng-content></label>
	<input 
		[name]="inputName" 
		type="text" 
		class="form-control"
		[(ngModel)]="inputValue" 
		[placeholder]="placeholder" 
		[appDatepicker]="" 
		(dateSelected)="inputValue = $event;updateFormInputValue();"/>
	<app-form-help-text [helpText]="helpText"></app-form-help-text>
</div>
